import {
  Suspense,
  lazy
} from 'react';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { appRoutes } from 'Config/route';
import 'nprogress/nprogress.css';
import PrivateRoute from 'Components/PrivateRoute';
import PageNotFound from 'Screens/PageNotFound';
import SsoCallback from 'Screens/SsoCallback';
import Redirect from 'Screens/Redirect';

function Routes() {
  const privateRoute = [
    {
      path: appRoutes.HEADCOUNT_SCREEN,
      name: 'Headcount',
      exact: true,
      component: lazy(() => import('Screens/Headcount')),
      isShow: true,
    },
    {
      path: appRoutes.ATTENDANCE_SCREEN,
      name: 'Attendance',
      exact: true,
      component: lazy(() => import('Screens/Attendance')),
      isShow: true,
    },
    {
      path: appRoutes.PAYROLL_SCREEN,
      name: 'Payroll',
      exact: true,
      component: lazy(() => import('Screens/Payroll')),
      isShow: true,
    },
    {
      path: appRoutes.EMPLOYEE_AT_RISK,
      name: 'Employee At Risk',
      exact: true,
      component: lazy(() => import('Screens/EmployeeAtRisk')),
      isShow: true,
    },
    {
      path: appRoutes.EMPLOYEE_PERFORMANCE_SCREEN,
      name: 'Employee Performance',
      exact: true,
      component: lazy(() => import('Screens/EmployeePerformance')),
      isShow: true,
    },
    {
      path: appRoutes.OVERTIME_SCREEN,
      name: 'Overtime',
      exact: true,
      component: lazy(() => import('Screens/Overtime')),
      isShow: true,
    },
    {
      path: appRoutes.CUSTOM_DASHBOARD,
      name: 'Custom Dashboard',
      exact: true,
      component: lazy(() => import('Screens/CustomDashboard')),
      isShow: true,
    },
    {
      path: appRoutes.EXPORT_HISTORY,
      name: 'Download File',
      exact: true,
      component: lazy(() => import('Screens/ExportHistory')),
      isShow: true,
    },
  ];

  return (
    <Router>
      <Suspense fallback=''>
        <Switch>
          {/* this end point just return a dummy HTML */}
          <Route path="/health-check">
            <h3>Hi there, this site is Healthy</h3>
          </Route>

          {/* All routes with verification */}
          {privateRoute
            .filter((e) => e.isShow)
            .map((route) => (
              <PrivateRoute
                key={route.path}
                {...route}
                additionalRoute={route}
              />
            ))}

          <Route path={appRoutes.SSO_CALLBACK} render={() => <SsoCallback />} />
          <Route path={appRoutes.REDIRECT} render={() => <Redirect />} />
          <Route path="/*" render={() => <PageNotFound />} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default Routes;
